export default {
  oops: 'Oops!',
  validOrigin: 'Si prega di selezionare una posizione di partenza valida',
  validDestination: 'Si prega di selezionare una destinazione valida',
  validOutboundDate: 'Si prega di selezionare una data di partenza valida',
  validReturnDate: 'Si prega di selezionare una data di ritorno valida',
  validChildAges: "Si prega di selezionare l'età di tutti i bambini",
  oneChild: 'È consentito 1 solo bambino (età 0- 2 anni) per adulto',
}
